var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showValue)?_c('div',{staticClass:"proposal-argument"},[(_vm.proposal)?_c('ProposalInfo',{attrs:{"proposal":_vm.proposal}}):_vm._e(),_c('ClampedText',[_vm._v(" "+_vm._s(_vm.proposalText)+" ")])],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }